// SCSS
import styles from "./index.module.scss";
// COMPONENTS
import CheckBox from "../FormControl/CheckBox/CheckBox";

import { useProduct } from "../../Context/ProductCrud/useProduct";

function DeliveryInfo(props) {
  
  const {
    productState,
    setAddonAdminOnly,
  } = useProduct();

  const nonLocalOnly = productState.is_non_local_only ?? false;
  const isAddon = productState.product_primary_info?.type === "ADD_ONS";
  const addonAdminOnly = productState.addon_admin_only ?? false;

  return (
    <div className={`${styles.productsWrapper}`}>
      <div className="">
        <div className="">
          <div className={styles.title} id="is-local">Delivery Info</div>
          <div className={`row`}>
            <div className={`col-md-12 text-left mt-2 mb-4 ${styles.checkBox}`}>
              
              <CheckBox
                label="Available for nonlocal delivery"
                value={nonLocalOnly}
                required={true}
                submitStatus={props.submitStatus}
                onChange={(data) => props.setIsNonLocal(data)}
                id="is_non_local_only"
                disabled={props.isDisableFields}
               />
               {isAddon && (
                 <CheckBox
                   label="Admin only (hide from storefront)"
                   value={addonAdminOnly}
                   required={true}
                   submitStatus={props.submitStatus}
                   onChange={(data) => setAddonAdminOnly(data)}
                   id="addon_admin_only"
                   disabled={props.isDisableFields}
                  />
               )}
               <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryInfo;
